import { createAction, props, createReducer, on } from '@ngrx/store';
import { CurrentBookingReducer } from '../models/current-booking-reducer.interface';

// Action definitions using createAction
export const updateBookingObject = createAction(
  '[CurrentBooking] Update Booking Object',
  props<{ payload: any }>()
);

export const updateAmendObject = createAction(
  '[CurrentBooking] Update Amend Object',
  props<{ payload: any }>()
);

export const refreshBookingObject = createAction(
  '[CurrentBooking] Refresh Booking Object',
  props<{ payload: any }>()
);

export const resetBookingObject = createAction(
  '[CurrentBooking] Reset Booking Object'
);

export const updateTimeslotServiceDate = createAction(
  '[CurrentBooking] Update Timeslot Service Date',
  props<{ payload: string }>()
);

// Initial state
const initState: CurrentBookingReducer = {
  currentBooking: {},
  amendBooking: {},
  timeSlotServiceDate: ''
};

// Reducer using createReducer and on
export const currentBookingReducer = createReducer(
  initState,
  on(updateBookingObject, (state, { payload }) => ({
    ...state,
    currentBooking: payload
  })),
  on(updateAmendObject, (state, { payload }) => ({
    ...state,
    amendBooking: payload
  })),
  on(refreshBookingObject, (state, { payload }) => ({
    ...payload // Directly use payload as the new state
  })),
  on(resetBookingObject, () => ({ ...initState })),
  on(updateTimeslotServiceDate, (state, { payload }) => ({
    ...state,
    timeSlotServiceDate: payload
  }))
);
